<template lang="html">
  <div class="cancelReason">
    <div class="item-cells">
      <div
        class="item-cell"
        v-for="(reason, index) in refundReasons"
        :class="{ active: index === checked }"
        @click="chooseReason(index, reason)"
      >
        <div class="item-cell-bd">{{ reason }}</div>
      </div>
    </div>
    <div class="actions">
      <button @click="confirmRefund">确认</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      checked: -1,
      reason: ''
    }
  },
  computed: {
    ...mapState(['order', 'refundReasons'])
  },
  methods: {
    chooseReason(i, reason) {
      this.checked = i
      this.reason = reason
    },
    async confirmRefund() {
      if (this.reason === '') {
        this.$$toast('请选择退单原因')
        return
      }
      const payType = (this.params.payType || 1) * 1
      const { uid, skey } = await this.$$ensureLogin()
      let res = ''
      if (this.order.partnerType * 1 === 9) {
        res = await this.$store.dispatch('returnOrderOld', {
          uid,
          skey,
          orderId: this.order.orderId
        })
        if (res.code * 1 === 0) {
          this.order.refundState = 20
          this.$store.commit('hideActionSheet')
          await this.$store.dispatch('getOrderDetail', {
            uid: this.$$cookie('uid'),
            skey: this.$$cookie('skey'),
            orderCode: this.order.orderId
          })
          this.$$toast('申请退单成功')
        } else if (res.code * 1 === 2) {
          this.$$login()
        } else {
          this.$$toast('系统异常，请稍后再试')
        }
      } else {
        res = await this.$store.dispatch('returnOrder', {
          uid,
          skey,
          vorder_id: this.order.orderId,
          refund_reason: this.reason,
          platform_id: 1
        })
        if (res.code * 1 === 1) {
          this.order.refundState = 20
          this.$store.commit('hideActionSheet')
          await this.$store.dispatch('getOrderDetail', {
            uid: this.$$cookie('uid'),
            skey: this.$$cookie('skey'),
            orderCode: this.order.orderId
          })
          if (payType === 2) {
            // POS支付
            location.href = `/v/order/payment/${this.order.orderId}?cmd=share&sharetype=0&refresh=no&type=2`
          } else {
            this.$$toast('申请退单成功')
          }
        } else if (res.code * 1 === 4) {
          this.$$login()
        } else {
          this.$$toast(res.msg)
        }
      }
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.cancelReason {
  height: 100%;

  // position: relative;
  .selected {
    color: #ff5900;
  }
  .item-cells {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: rem(100px);
    overflow-x: hidden;
    overflow-y: auto;
  }
  .actions {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;

    button {
      display: block;
      width: 100%;
      text-align: center;
      line-height: rem(98px);
      color: #fff;
      font-size: rem(36px);
      background: #ff5900;
    }
  }
  .active {
    color: #ff5900;
  }
}
</style>
